import React, { useState } from 'react';
import { B as Button } from './Button-DJQVVE0-.js';
import { T as Tooltip } from './Tooltip-B50E53VM.js';
import { D as DataListActionsMenu } from './DataListActionsMenu-Cwed3dNg.js';

function DataListItemActionsOverflow({ actions, }) {
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const [showMenu, setShowMenu] = useState(false);
    if (actions.length === 0)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { message: "More actions" },
            React.createElement(Button, { icon: "more", ariaLabel: "More actions", type: "secondary", variation: "subtle", onClick: handleMoreClick })),
        React.createElement(DataListActionsMenu, { visible: showMenu, position: menuPosition, onRequestClose: handleClose }, actions)));
    function handleMoreClick(event) {
        // Prevent firing the parent's onClick event when it is nested
        // within a clickable list item
        event.stopPropagation();
        // Prevent navigating to the parent's href event when it is nested within a
        // linked list item
        event.preventDefault();
        setShowMenu(true);
        const rect = event.currentTarget.getBoundingClientRect();
        const posX = rect.x;
        const posY = rect.y + rect.height;
        setMenuPosition({ x: posX, y: posY });
    }
    function handleClose() {
        setShowMenu(false);
    }
}

export { DataListItemActionsOverflow as D };
